import { lazy } from 'react';

export const PlayerRemoveLossLimitForm = lazy(
  () => import('./PlayerRemoveLossLimitForm'),
);
